import { OfficeEditor } from './_components/OfficeEditor';
import { OfficeEditorView } from './_components/OfficeEditorView';
import { officeRoutes } from './routes';

import { createAppModule } from '~/shared/routing/createAppModule';
import { createModuleNav } from '~/shared/routing/createModuleNav';
import { createModuleRoutes } from '~/shared/routing/createModuleRoutes';

const routeDefinitions = createModuleRoutes({
  root: {
    path: officeRoutes.root,
    label: (t) => t.menu.office?.root || 'Office',
  },
  editor: {
    path: officeRoutes.editor,
    label: (t) => t.menu.office?.root || 'Office',
    component: OfficeEditorView,
  },
});

const officeNav = createModuleNav(($) =>
  $(routeDefinitions.root, [$(routeDefinitions.editor)]),
);

export const officeModule = createAppModule({
  routes: routeDefinitions,
  nav: officeNav,
});

// Re-export components that might be used elsewhere
export { OfficeEditor };
